import React, { createRef, useRef } from 'react'

import { LeftContent, ContentRight, HeaderContent, GridStyles, ListStyles, footerDocs } from './styles'
import SearchInput from '../../../components/Input/SearchInput'
import { Row } from '../../../components/commons'
import FileDetails from '../Documents/FileDetails'
import useDocuments, { Document } from '../../../services/documents.service'
import { api } from '../../../services/api'
import BreadCrumb from './BreadCrumb'
import { useDirectory } from '../../../store/directory'
import ListItem from './ListItem'
import HeaderTable from './HeaderTable'
import { LoaderComponent } from '../../../components/Button/styles'
import { theme } from '../../../styles/theme'
import { useNavigate } from 'react-router-dom'
import { FaFileLines, FaFolder } from 'react-icons/fa6'
import Filters from './Filters'
import { backgrounds } from 'polished'
import CustomFolderTree from '../../../components/CustomFolderTree'

export interface DocumentsProps {}
let arquivos = []
let numfolder = 0
let numfiles = 0
let columns = [
  {
    _id: 1,
    sort: 'name',
    name: 'Nome do Arquivo',
  },
  {
    _id: 2,
    sort: 'createdAt',
    name: 'Data',
  },
  {
    _id: 3,
    sort: 'documentType',
    name: 'Tipo',
  },
  {
    _id: 4,
    sort: 'pages',
    name: 'Páginas',
  },
  {
    _id: 5,
    sort: 'size',
    name: 'Tamanho',
  },
    
]
const FooterDocs = ({
  files,
  numfolder,
  numfiles,
}: {
  files : any
  numfolder: number
  numfiles: number
}) => {
  if (files) {
    numfiles = 0
    numfolder = 0 
    for (let i = 0; i < files.length; i++){
      files[i].isFolder ? numfolder++ : numfiles++
    }
  }
  return (
    <div id = 'footer' style={{justifyContent:'center', textAlign:'center', color:theme.colors.primary, backgroundColor:'#f5f5f5', padding:'10px', borderRadius:'8px'}}>
      <h3> {numfolder} Pastas {numfiles} Documentos</h3>
    </div>
  )
}

// Função para converter dados de documentos em estrutura hierárquica
const convertToTreeData = (files: Document[]): any => {
  if (!files || files.length === 0) {
    return {
      name: 'Documentos',
      children: []
    };
  }

  // Separar pastas e arquivos
  const folders = files.filter(file => file.isFolder);
  const documents = files.filter(file => !file.isFolder);

  // Ordenar pastas alfabeticamente
  const sortedFolders = folders.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));

  // Ordenar documentos alfabeticamente
  const sortedDocuments = documents.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));

  // Criar opção "Início" para listar todos os documentos na raiz
  const inicioNode = {
    name: 'Início',
    id: 'root',
    isFolder: true,
    children: []
  };

  // Criar estrutura de pastas (ordenadas)
  const folderNodes = sortedFolders.map(folder => ({
    name: folder.name,
    id: folder._id,
    isFolder: true,
    children: [] // Por enquanto vazio, pode ser expandido futuramente
  }));

  // Criar estrutura de documentos (ordenados)
  const documentNodes = sortedDocuments.map(doc => ({
    name: doc.name,
    id: doc._id,
    isFolder: false,
    size: doc.size,
    mimetype: doc.mimetype,
    createdAt: doc.createdAt
  }));

  // Combinar "Início" (primeiro), pastas e documentos
  const allNodes = [inicioNode, ...folderNodes, ...documentNodes];

  return {
    name: 'Documentos',
    id: 'root',
    children: allNodes
  };
};

const BasicTree = ({
  onClickItem,
  onDoubleClickItem,
  modalSideBar,
  currentFolderId
} : {
  onClickItem: (file: Document, e: any) => void
  onDoubleClickItem: (file: Document, e: any) => void
  modalSideBar: React.RefObject<FileDetailsRef>
  currentFolderId?: string | null
}) => {
  // Estado para armazenar dados da árvore
  const [treeData, setTreeData] = React.useState<any>(null);
  const [allFiles, setAllFiles] = React.useState<Document[]>([]);

  // Hook para buscar dados iniciais
  const { data: initialData } = useDocuments(
    1, // página 1
    5000, // muitos itens para pegar tudo
    '', // sem busca
    undefined, // sem ordenação específica
    [], // diretório raiz (vazio)
    {} // sem filtros
  );

  // Atualizar dados da árvore apenas quando os dados iniciais mudarem
  React.useEffect(() => {
    if (initialData?.data) {
      setAllFiles(initialData.data);
      const convertedData = convertToTreeData(initialData.data);
      setTreeData(convertedData);
    }
  }, [initialData?.data]);

  const onNameClick = (nodeData: any) => {
    // Se for a opção "Início", navegar para a rota principal
    if (nodeData && (nodeData.id === 'root' || nodeData._id === 'root')) {
      useDirectory.getState().setDirectory([
        {
          name: 'Início',
          url: '/',
        },
      ]);
      return;
    }
    
    if (nodeData && (nodeData.id || nodeData._id)) {
      // Encontrar o documento correspondente nos dados originais
      const originalDocument = allFiles.find(file => file._id === (nodeData.id || nodeData._id));
      
      if (originalDocument) {
        // Apenas pastas são exibidas na árvore, então sempre navegar
        let directories = [{
          name: originalDocument.name,
          url: originalDocument._id,
        }]
        useDirectory.getState().setDirectory(directories)
        modalSideBar.current?.closeModal()
      } else {
        // Se não encontrou nos dados originais, pode ser uma subpasta carregada dinamicamente
        // Neste caso, usar os dados diretamente do nodeData
        let directories = [{
          name: nodeData.name,
          url: nodeData._id || nodeData.id,
        }]
        useDirectory.getState().setDirectory(directories)
        modalSideBar.current?.closeModal()
      }
    }
  };

  if (!treeData) {
    return (
      <div style={{ 
        padding: '10px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px', 
        marginTop: '10px',
        border: `1px solid ${theme.colors.primary}20`,
        height: '95%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h4 style={{ 
          margin: '0 0 10px 0', 
          color: theme.colors.primary, 
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          📁 Estrutura de Documentos
        </h4>
        <div style={{ 
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.colors.primary,
          fontSize: '12px'
        }}>
          Carregando estrutura...
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '10px', 
      backgroundColor: '#f8f9fa', 
      borderRadius: '8px', 
      marginTop: '10px',
      border: `1px solid ${theme.colors.primary}20`,
      height: '95%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <h4 style={{ 
        margin: '0 0 10px 0', 
        color: theme.colors.primary, 
        fontSize: '14px',
        fontWeight: 'bold'
      }}>
        📁 Estrutura de Documentos
      </h4>
      <div style={{ 
        flex: 1,
        overflow: 'hidden'
      }}>
        <CustomFolderTree
          treeData={treeData}
          onNameClick={onNameClick}
          selectedFolderId={currentFolderId}
          style={{
            height: '100%',
            overflow: 'auto'
          }}
        />
      </div>
    </div>
  );
}





const GridFolder = ({
  arquivos,
  isActive,
  files,
  onClickItem,
  onDoubleClickItem,
  onSubmitOrder,
}: {
  arquivos : any
  files?: Document[]
  fileRefs: any
  isActive: boolean
  onClickItem: (file: Document, e: any) => void
  onDoubleClickItem: (file: Document, e: any) => void
  onSubmitOrder: (name: string, order: string) => void
}) => {
  arquivos = files 
  return (
    <div style={{ paddingTop: 15, display: isActive ? 'flex' : 'none', flexWrap: 'wrap', flex: 1, overflowY: 'auto', alignContent: 'flex-start' }}>
      {files?.map((item) => (
        <GridStyles.Content
          key={item._id}
          onDoubleClick={(e) => onDoubleClickItem(item, e)}
          onClick={(e) => {
            onClickItem(item, e)
          }}>
          {item.isFolder ? <FaFolder size={20} /> : <FaFileLines size={20} />}
          <GridStyles.Name>{item.name}</GridStyles.Name>
        </GridStyles.Content>
      ))}
    </div>
  )
}

const ListFolder = ({
  isActive,
  files,
  onClickItem,
  onDoubleClickItem,
  onSubmitOrder,
  fileRefs,
  
}: {
  isActive: boolean
  files?: Document[]
  fileRefs: any
  onClickItem: (file: Document, e: any) => void
  onDoubleClickItem: (file: Document, e: any) => void
  onSubmitOrder: (name: string, order: string) => void
  
}) => {
  return (
    <ListStyles.Content style={{ display: isActive ? 'block' : 'none' }}>
      {files?.map((file, index) => {
        return (
          <ListItem
            key={file._id}
            file={file}
            ref={fileRefs[index]}
            onClickItem={onClickItem}
            onDoubleClickItem={onDoubleClickItem}
            isEven={index % 2 === 0}
          />
        )
      })}
    </ListStyles.Content>
  )
}

const footerConDoc = ({
  files,
  fileRefs
}: {
  files?: Document[]
  fileRefs: any
}) => {
  return(
    <footerDocs.Content>
      
    </footerDocs.Content>
  )
}

type FileDetailsRef = React.ElementRef<typeof FileDetails>

const Documents: React.FunctionComponent<DocumentsProps> = () => {
  const [page, setPage] = React.useState<number>(1)
  const [search, setSearch] = React.useState('')
  const [list, setList] = React.useState(true)
  const [sort, setSort] = React.useState<any>({ name: 'asc' })

  const [filter, setFilter] = React.useState<any>({})
  const directory = useDirectory((state) => state.directory)
  
  // Obter o ID da pasta atual para sincronização
  const getCurrentFolderId = () => {
    if (directory.length === 0 || (directory.length === 1 && directory[0].url === '/')) {
      return 'root' // Pasta raiz
    }
    return directory[directory.length - 1].url // Última pasta no breadcrumb
  }
  const [isLoadingRef, setisLoadingRef] = React.useState(true)
  const nav = useNavigate()
  
  const modalSideBar = React.useRef<FileDetailsRef>(null)

  // Tratar pasta raiz de forma especial - quando tem apenas '/' ou array vazio
  const getDirectoryParam = () => {
    const mappedDirectory = directory.map((el) => el.url)
    // Se tem apenas a pasta raiz ('/'), retornar array vazio para buscar documentos na raiz
    if (mappedDirectory.length === 1 && mappedDirectory[0] === '/') {
      return []
    }
    return mappedDirectory
  }

  // Busca local (pasta atual)
  const { isLoading: isLoadingLocal, data: dataLocal, refetch: refetchLocal, dataUpdatedAt: dataUpdatedAtLocal } = useDocuments(
    page,
    5000,
    search,
    sort,
    getDirectoryParam(),
    filter,
  )

  // Usar apenas busca local
  const isLoading = isLoadingLocal
  const data = dataLocal
  const refetch = refetchLocal
  const dataUpdatedAt = dataUpdatedAtLocal


  const fileRefs: any = useRef([])

  const onSubmitOrder = (name: string, sort: string) => {
    setSort({
      [name]: sort,
    })
  }

  const onSearch = async (search: string) => {
    setSearch(search)
  }


  const onSelectAllValues = (check: boolean) => {
    fileRefs.current.map((ref: any) => {
      ref?.current?.checkValue?.(check)
    })
  }

  const onClickItem = (file: Document, e: any) => {
    // Para pastas, abrir modal de informações
    if (file.isFolder) {
      modalSideBar.current?.openModal(file?._id)
    } else {
      // Para arquivos, abrir modal de visualização
      modalSideBar.current?.openModal(file?._id)
    }
    e.stopPropagation()
  }

  const onDoubleClickItem = (file: Document, e: any) => {
    if (file.isFolder) {
      // Criar novo diretório apenas com a pasta clicada
      let directories = [{
        name: file.name,
        url: file._id,
      }]
      useDirectory.getState().setDirectory(directories)
      modalSideBar.current?.closeModal()
      e.stopPropagation()
    } else {
      //nav(`/document/${file._id}`)
      nav(`/document/${file._id}`)
    }
  }

  React.useEffect(() => {
    if (isLoading) return
    if (data?.data && data?.data.length > 0) {
      data.data.map((_, i) => fileRefs?.current[i] || fileRefs.current.push(createRef()))
      setisLoadingRef(false)
    } else {
      setisLoadingRef(false)
    }
  }, [data?.data, dataUpdatedAt, isLoading])

  return (
    <>
      <LeftContent>
        <BasicTree 
          onClickItem={onClickItem}
          onDoubleClickItem={onDoubleClickItem}
          modalSideBar={modalSideBar}
          currentFolderId={getCurrentFolderId()}
        /> 
      </LeftContent>
      <ContentRight>
        <HeaderContent.Content>
          <BreadCrumb refetch={refetch} fileRefs={fileRefs} />
          <Row gap={5}>
            <SearchInput 
              isLoading={isLoading} 
              onSearch={onSearch} 
              placeholder="Buscar na pasta atual"
              showGlobalSearch={false}
            />
            <Filters setFilter={setFilter} filter={filter} />
          </Row>
          <HeaderContent.Columns>
            {columns.map((column, index) => (
              <HeaderTable
                key={index}
                isActive={list}
                onSubmitOrder={onSubmitOrder}
                column={column}
                index={index}
                onSelectAllValues={onSelectAllValues}
              />
            ))}
          </HeaderContent.Columns>
        </HeaderContent.Content>
        
        {isLoadingRef && (
          <div style={{ margin: 'auto', marginTop: 50 }}>
            <LoaderComponent color={theme.colors.primary} />
          </div>
        )}
        {!isLoadingRef && (
          <ListFolder
            isActive={list}
            fileRefs={fileRefs?.current}
            files={data?.data}
            onClickItem={onClickItem}
            onSubmitOrder={onSubmitOrder}
            onDoubleClickItem={onDoubleClickItem}
          />
        )}
        {!isLoadingRef && (
          <FooterDocs
            files = {data?.data}
            numfolder={numfolder}
            numfiles={numfiles}
          />
        )}
        {!isLoadingRef && (
          <GridFolder
            arquivos={data?.data}
            isActive={!list}
            fileRefs={fileRefs?.current}
            files={data?.data}
            onSubmitOrder={onSubmitOrder}
            onClickItem={onClickItem}
            onDoubleClickItem={onDoubleClickItem}
          />
        )}
        
      
      </ContentRight>      
      
      <FileDetails ref={modalSideBar} />
    </>
    //<FileDetails refetch={refetch} ref={modalSideBar} />
    
  )
}

export default Documents
